"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QnAContentsHead = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const common_1 = require("../../../../common");
const FileDown_1 = require("../../../../common/option/FileDown");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const account_1 = require("../../../base/account");
const QnAItem_1 = require("../DTST004_List_Child/QnAItem");
exports.QnAContentsHead = react_1.default.memo(({ data, isQuestion, children, isTeacher, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const isViewerAdmin = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsManager)(state));
    const show_list = (0, react_1.useMemo)(() => isQuestion
        ? [
            ['register', 'creation_time'],
            ['category', 'attachFile'],
        ]
        : [['register', 'creation_time'], ['attachFile']], [isQuestion]);
    const getData = (type) => {
        switch (type) {
            case 'register':
                if (!isViewerAdmin && data.author_level === '04')
                    return '관리자';
                return isTeacher ? `${data.author_name} (${data.author_idf})` : `${(0, QnAItem_1.hideName)(data.author_name)} (${(0, QnAItem_1.hideID)(data.author_idf)})`;
            case 'creation_time':
                return (0, moment_1.default)(data.creation_time).format('YYYY-MM-DD, HH:mm');
            case 'category':
                return t(`supportRoom.${data.category}`);
            case 'attachFile':
                return react_1.default.createElement(FileDown_1.FileDown, { files: data.files, isOpen: true });
            default:
                return '-';
        }
    };
    return (react_1.default.createElement("div", { className: "sub-info" },
        react_1.default.createElement("div", { className: isMobile ? 'icon-question-mobile' : 'icon-question' },
            react_1.default.createElement("div", { className: "ellipse-2126" },
                react_1.default.createElement(common_1.Icon, { icon: isQuestion ? 'question-icon' : 'answer-icon', width: 18, height: 14 }),
                react_1.default.createElement("div", { className: "div" }, isQuestion ? '질문' : '답변완료'))),
        react_1.default.createElement("div", { className: "frame-987343-wrap" }, show_list.map((list, index) => (react_1.default.createElement("div", { className: `frame-987343 ${index === 0 ? 'one' : 'two'}`, key: index }, list.map((item, idx) => (react_1.default.createElement("div", { className: `sub-item ${item}`, key: idx },
            react_1.default.createElement("div", { className: "label" }, t(`supportRoom.${item}`)),
            react_1.default.createElement("div", { className: "divider" }),
            react_1.default.createElement("div", { className: "value overText" }, getData(item))))))))),
        children));
});
